import { useQuery } from "@tanstack/react-query";
import { getMyProfile } from "apis";

const useGetMyProfile = () => {
  return useQuery({
    queryFn: getMyProfile,
    queryKey: getMyProfileQueryKeys(),
    staleTime: 10 * 60 * 1000,
  });
};

export function getMyProfileQueryKeys() {
  return ["get-my-profile"];
}

export default useGetMyProfile;
